import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {ApplicationDTO} from "ngx-heka-design-lib";

@Component({
    selector: 'ngx-l2-assigned-application-list',
    templateUrl: './assigned-application-list.component.html',
    styleUrls: ['./assigned-application-list.component.scss'],
    standalone: false,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AssignedApplicationListComponent {
   assignedApplications= input<ApplicationDTO[]>([]);

}
